import { Place } from "@mui/icons-material";
import { Avatar, Box, Typography, useTheme } from "@mui/material";
import { ContainerTransportMapMarkerProps } from "@sal/onevent-portal";

export function ContainerTransportContainerMapMarker({ locationName }: ContainerTransportMapMarkerProps) {
	const theme = useTheme();
	const topLabelBackgroundColorFromTheme = theme.palette.primary.main;

	return (
		<Box
			sx={{
				position: "relative",
				display: "inline-flex"
			}}
		>
			{locationName && (
				<Typography
					component="div"
					sx={{
						position: "absolute",
						bottom: "calc(100% + 3px)",
						left: "50%",
						transform: "translateX(-50%)",
						backgroundColor: topLabelBackgroundColorFromTheme,
						color: "white",
						fontSize: "10px",
						fontWeight: "bold",
						fontFamily: "Arial, sans-serif",
						paddingTop: "4px",
						paddingBottom: "4px",
						paddingLeft: "16px",
						paddingRight: "16px",
						borderRadius: "10px",
						whiteSpace: "nowrap",
						boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
						zIndex: 1,
						pointerEvents: "none"
					}}
				>
					{locationName}
				</Typography>
			)}
			<Avatar
				sx={{
					height: "24px",
					width: "24px",
					backgroundColor: theme.palette.primary.main,
					fontSize: "16px"
				}}
			>
				<Place fontSize="inherit" sx={{ color: theme.palette.primary.contrastText }} />
			</Avatar>
		</Box>
	);
}
